import HOC from './hoc.component'

export default HOC
